import { formatPickupTimestamp } from './format'
import { getToken } from '../core/HttpClient'

export function formatAttributes (formAttributes) {
  const attributes = []
  formAttributes.forEach(attribute => {
    if (attribute.checked) {
      switch (attribute.name) {
        case 'djur':
          attributes.push('pet')
          break
        case 'kombi':
          attributes.push('stationWagon')
          break
        case 'bilkudde':
          if (attribute.numberSelect.value === 1) {
            attributes.push('boosterSeat1')
          } else {
            attributes.push('boosterSeat2')
          }
          break
        case 'bakåtvänd bilbarnstol':
          attributes.push('rearFacingChildSeat')
          break
      }
    }
  })
  return attributes
}

export function formatCarType (order, carTypes, fixedPrice) {
  const checkedCarType = carTypes.find(c => c.checked)

  if (!checkedCarType) {
    return order
  }

  let serviceType = ''
  let vehicleOptions = [...order.vehicleOptions]

  switch (checkedCarType.name) {
    case 'taxi':
      serviceType = 'taxi'
      break
    case 'business':
      serviceType = 'business'
      vehicleOptions = []
      break
    case 'storbil':
      serviceType = 'largeCar'
      vehicleOptions = [...vehicleOptions, 'largeCar7']
      break
  }

  if (fixedPrice && checkedCarType.estimate && checkedCarType.estimate.priceToken) {
    order.priceToken = checkedCarType.estimate.priceToken
  }

  return Object.assign({}, order, {
    vehicleOptions,
    serviceType
  })
}

export function formatLocation (location) {
  return (location.address !== undefined) ? { id: location.id, ...location.address } : location
}

export function formDataToDeparture (formData) {
  return formatLocation((formData.departure && formData.departure.selected) ? formData.departure.location : formData.location.departure)
}

export function formDataToDestination (formData) {
  if (formData.destination && formData.destination.selected) {
    return formatLocation(formData.destination.location)
  }
  else if (formData.useLocationAsDestination) {
    return formatLocation(formData.location.departure)
  }
  return null
}

export function formDataToOrder (formData) {
  let phone

  if (formData.phone !== '') {
    phone = formData.phone
  }
  else {
    phone = formData.location && formData.location.phone ? formData.location.phone : ''
  }

  let order = {
    userId: 0,
    externalUserId: getToken(),
    generalComment: formData.location.message ? formData.location.message + ' ' + formData.message : formData.message,
    traveler: {
      name: formData.name || formData.location.name, // v3 default to location name if traveler name is empty
      phoneNumber: phone
    },
    vehicleOptions: formatAttributes(formData.attributes)
  }

  if (formData.sendSMS === true && formData.phone !== '') {
    order.callbackData = {
      eta: true
    }
  }

  if (formData.bookingCommissionId) {
    order.bookingCommissionId = formData.bookingCommissionId
  }

  if(formData.reference) order.invoiceReference = formData.reference;
  
  if (formData.location && formData.location.passenger && formData.location.passenger.payment) {
    order.accountInfo = {
      number: parseInt(formData.location.passenger.payment.account),
      password: formData.location.passenger.payment.accountPassword,
      type:'TSAB',
    } 
    order.paymentMethod = 'TSABAccount'
  }
  else {
    order.paymentMethod = 'PayInCar'
  }

  order.originLocation = formDataToDeparture(formData)

  const destination = formDataToDestination(formData)
  if (destination) order.destinationLocation = destination

  order = formatCarType(order, formData.carTypes, formData.fixedPrice)

  if (formData.preBooking.edited) {
    order.pickUpTimeStamp = formatPickupTimestamp(formData.preBooking.date + ' ' + formData.preBooking.time)
  }

  if (formData.flightNumber !== '') {
    order.originLocation.flightInfo = {
      flightNumber: formData.flightNumber.toUpperCase(),
      checkedInBaggage: formData.baggage
    }
  }

  return order
}

export function formDataToOrderEstimate (formData) {
  const order = { }

  if (formData.preBooking.edited) {
    order.pickUpTimeStamp = formatPickupTimestamp(formData.preBooking.date + ' ' + formData.preBooking.time)
  }
  order.originLocation = formDataToDeparture(formData)
  order.destinationLocation = formDataToDestination(formData)
  order.serviceTypes = ['taxi', 'business', 'largeCar']
  if (formData.bookingCommissionId) {
    order.bookingCommissionId = formData.bookingCommissionId
  }

  return order
}

export function convertQueryToLocation (query) {
  return {
    location: {
      departure: {
        address: {
          streetName: query.streetName,
          streetNumber: parseInt(query.streetNumber),
          city: 'Stockholm'
        }
      }
    },
    token: query.token
  }
}
